<div class="shared-container">
  <ng-container *ngIf="sucesso; else formRelato">
    <app-sucesso
      [mensagem]="'Relato editado com sucesso!'"
      [botaoTexto]="'Continuar'"
      (continuar)="continuar()"
    ></app-sucesso>
  </ng-container>
  <ng-template #formRelato>
    <div class="form-content">
      <label for="titulo">TÍTULO DO RELATO</label>
      <input
        id="titulo"
        type="text"
        [(ngModel)]="titulo"
        class="form-control"
        placeholder="Título do relato"
      />
      <label for="descricao">DESCRIÇÃO DO RELATO</label>
      <textarea
        id="descricao"
        [(ngModel)]="descricao"
        class="form-control"
        placeholder="Descreva o relato..."
      ></textarea>
      <div class="contatos-email">
        <input type="checkbox" [(ngModel)]="enviarEmail" />
        <span>Enviar informações por e-mail</span>
      </div>
      <div class="dropdown-multiselect">
        <div class="dropdown-header" [class.disabled]="!enviarEmail">
          <ng-container *ngIf="selectedResponsaveis.length === 0">
            <span class="placeholder">Selecione os contatos</span>
          </ng-container>
          <ng-container *ngIf="selectedResponsaveis.length > 0">
            <span class="selected-list">
              {{
                selectedResponsaveis.length === responsavel.length
                  ? "Todos os contatos selecionados"
                  : selectedResponsaveis.length + " contato(s) selecionado(s)"
              }}
            </span>
          </ng-container>
          <span class="arrow">&#9662;</span>
        </div>
        <div *ngIf="enviarEmail" class="dropdown-list">
          <label class="select-all">
            <input
              type="checkbox"
              [checked]="selectedResponsaveis.length === responsavel.length"
              (change)="toggleSelectAll($event)"
            />
            Selecionar todos
          </label>
          <div class="divider"></div>
          <label *ngFor="let r of responsavel">
            <input
              type="checkbox"
              [checked]="isSelected(r)"
              (change)="toggleSelection(r)"
            />
            {{ r.name }}
          </label>
        </div>
      </div>
    </div>
    <div class="footer-actions">
      <button class="btn btn-secondary" type="button" (click)="clear()">
        LIMPAR DADOS
      </button>
      <button class="btn btn-primary" type="button" (click)="editarRelato()">
        EDITAR RELATO
      </button>
    </div>
  </ng-template>
</div>
